import React from 'react';
import { Grid } from '@mui/material';
import imgConstants from '../../shared/imgConstants';
import '../../assets/scss/SplashScreen.scss';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles((theme) => ({
    logo: {
    width: '100px',
    height: '100px'
    }
    
}));

const SplashScreen = (props: any) => {
    const classes = useStyles(props);
    return (
        <Grid container flexDirection={'column'} alignItems={'center'} justifyContent={'center'} sx={{ background: '#ffffff', width: '100%', height: '100vh' }}>
            <Grid item>
                <img className={classes.logo} src={imgConstants.SPLASH_LOGO} alt='logo'></img>
            </Grid>
            <Grid item>
                <CircularProgress size='1rem' color='secondary' />
            </Grid>
        </Grid>
    );
};

export default SplashScreen;